import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';

export interface PrintReturn {
  doPrint: true;
  printOptions: {
    printCoordinatorHeader: boolean;
    printInformations: boolean;
  };
}

@Component({
  selector: 'app-modal-print-meeting',
  templateUrl: './modal-print-meeting.component.html',
  styleUrls: [
    './modal-print-meeting.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class ModalPrintMeetingComponent implements OnInit, AfterViewInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;
  public printCoordinatorHeader: boolean;
  public printInformations: boolean;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      printCoordinatorHeader: [this.printCoordinatorHeader],
      printInformations: [this.printInformations]
    });
  }

  ngAfterViewInit(): void {
  }

  public closeModal(doPrint = false): void {
    this.closeEmitter.emit({
      doPrint,
      printOptions: {
        printCoordinatorHeader: this.formGroup.get('printCoordinatorHeader').value,
        printInformations: this.formGroup.get('printInformations').value
      }
    } as PrintReturn);
  }

}
